import { CreateRequestDialog } from './index';
import React from 'react';
import { ICandidate } from 'common/request/interfaces/candidate';
import {
  DocumentTypeEnum,
  GroupDocumentTypeEnum,
} from 'common/document/enums/document-type.enum';
import requestService from 'store/request/service';
import {
  DIALOG_TYPES,
  useGlobalDialogContext,
} from 'App/components/Layouts/Dashboard/dialog/GlobalDialog';

interface ICreateRequestGlobalDialogProps {
  params?: {
    candidateFirstName?: string;
    candidateLastName?: string;
    candidatePhone?: string;
    candidateEmail?: string;
    candidateEmployeeId?: string;
    disableCandidateFields?: boolean;
  };
}

export const CreateRequestGlobalDialog = ({
  params,
}: ICreateRequestGlobalDialogProps) => {
  const { hideDialog, showDialog } = useGlobalDialogContext();

  const [createRequest, { isLoading }] =
    requestService.endpoints.createRequest.useMutation();

  const handleDialogToggle = () => {
    hideDialog();
  };

  const handleSubmitRequest = (candidate: ICandidate) => {
    const documentsGroups: GroupDocumentTypeEnum[] = [];
    const documentsNeeded: DocumentTypeEnum[] = [];
    for (const documentsNeededElement of candidate.documentsNeeded) {
      if (documentsNeededElement.value === GroupDocumentTypeEnum.ONBOARDING) {
        documentsNeeded.push(DocumentTypeEnum.DRIVER_LICENSE);
        documentsNeeded.push(DocumentTypeEnum.DOT_MEDICAL);
        documentsGroups.push(documentsNeededElement.value);
      } else {
        documentsNeeded.push(documentsNeededElement.value);
      }
    }

    createRequest({
      data: {
        candidateFirstName: candidate.candidateFirstName,
        candidateLastName: candidate.candidateLastName,
        candidateEmail: candidate.candidateEmail,
        candidatePhone: candidate.candidatePhone,
        candidateEmployeeId: candidate.candidateEmployeeId,
        documentGroupName: documentsGroups?.[0],
        documentsNeeded,
      },
    })
      .unwrap()
      .then((request) => {
        showDialog(DIALOG_TYPES.CONFIRM_REQUEST_DIALOG, {
          request,
        });
      });
  };

  return (
    <CreateRequestDialog
      isLoading={isLoading}
      open={true}
      setOpen={() => {
        handleDialogToggle();
      }}
      onSubmit={handleSubmitRequest}
      params={params}
    ></CreateRequestDialog>
  );
};
